import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import '../../../../libs/bulma.min.css';
import PbxContext from '../../../../context/PbxContext';
import { accessLocalStorage, valuesAnalyze, changeViewForms, userByEmail, exportSelectAllEndpoints, exportSelectAllQueues, updateUser } from '../../../../services';
import Loading from '../../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';

function UserById() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [endpoints, setEndpoints] = useState([]);
  const [queues, setQueues] = useState([]);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const history = useHistory();

  const fetchUser = async () => {
    const userFetched = await userByEmail({ email: itemsSelectedToEdit });

    if(itemsSelectedToEdit.length <= 0 || userFetched === 400) return history.push('/config/usuarios/lista');
    if(userFetched === undefined) setLoading(true);

    const fetchQueues = await exportSelectAllQueues();
    const fetchEndpoints = await exportSelectAllEndpoints();
    const itensEndpoints = fetchEndpoints.map((endpoint) => endpoint.endpoint).filter((e) => !isNaN(e));
    const itensQueues = fetchQueues.map((queue) => queue.queuesselect);

    setEndpoints(itensEndpoints);
    setQueues(itensQueues);

    setValues(userFetched);
    setLoading(false);
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    await fetchUser();
    return;
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, checkPassword, isTextAndSpace, checkText } = valuesAnalyze;

    if(name === 'endpointsviewer') {
      if (value === 'all' || value === 'none') return true;
      let checkValueIsNumber = checkNumber(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };

    if(name === 'email') {
      const emailIsValid = validEmail(value);
      changeScreen(emailIsValid, name);
      return emailIsValid;
    }

    if(name === 'password') {
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    if(name === 'role' || name === 'queuesviewer') {
      const checkValueIsCharacters = checkText(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
    
    if(name == 'name') {
      const checkValueIsCharacters = isTextAndSpace(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
    
    if(name == 'tenant') {
      const checkValueIsCharacters = isTextAndSpace(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    name === 'endpointsviewer' || name === 'queuesviewer' ? setValues((prevState) => prevState, values[name] = Array.from(item.selectedOptions, (option) => option.value)) : setValues((prevState) => prevState, values[name] = value )
    if(Object.keys(validate).length > 0) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const endpointsViewerAnalyse = () => {
    if (values['endpointsviewer']) values['endpointsviewer'].includes('all') ? values['endpointsviewer'] = ['all'] : null;
    if (values['endpointsviewer']) values['endpointsviewer'].includes('none') ? values['endpointsviewer'] = ['none'] : null;
    if (values['endpointsviewer']) values['endpointsviewer'].includes('all') && values['endpointsviewer'].includes('none') ? values['endpointsviewer'] = ['none'] : null;
    return;
  }

  const queuesViewerAnalyse = () => {
    if (values['queuesviewer']) values['queuesviewer'].includes('all') ? values['queuesviewer'] = ['all'] : null;
    if (values['queuesviewer']) values['queuesviewer'].includes('none') ? values['queuesviewer'] = ['none'] : null;
    if (values['queuesviewer']) values['queuesviewer'].includes('all') && values['queuesviewer'].includes('none') ? values['queuesviewer'] = ['none'] : null;
    return;
  }

  const sendDataUsersGenerate = async () => {
    endpointsViewerAnalyse();
    queuesViewerAnalyse();

    const fetchEndpoints = await updateUser(values);
    toggleIsChangeFormElements('alert-update-users', 'is-hidden');
    const result = Object.keys(fetchEndpoints).length > 0 ? true : false;
    if(result) {
      setLoading(false);
      changeVisibityMessages(true, 'update-form');
      changeVisibityMessages(true, 'button-send-form');
      changeVisibityMessages(false, 'success-update-users');
      setTimeout(() => {
        return window.location.reload(true)
      }, 3000);
    };
    return;
  };

  useEffect(() => {
    validateUserLogged()
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">ATUALIZAR DADOS DO USUÁRIO</strong><br/>
              <strong className="is-size-6 has-text-link">{ values['email'] }</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-update-users" name="alert-update-users" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-update-users') }></button>
            </div>
            <div className="message-body">
              Não é possível alterar usuário com os campos abaixo não preenchidos.
              <br />
              Por favor, verifique os dados e clique novamente no botão <strong>Alterar Usuário</strong> 
            </div>
          </article>
          <article id="error-create-endpoints" name="error-create-endpoints" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Erro!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#error-create-endpoints') }></button>
            </div>
            <div className="message-body">
              Não foi possível alterar o usuário!
              <br />
              Verifique se já existe!
            </div>
          </article>
          <article id="success-update-users" name="success-update-users" className="column is-half is-offset-one-quarter message is-info is-hidden">
            <div className="message-header">
              <p>Sucesso!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#success-update-users') }></button>
            </div>
            <div className="message-body">
              Usuário alterado com <strong>sucesso</strong>!
            </div>
          </article>
          <form name="update-form" id="update-form" onSubmit={ (e) =>  e.preventDefault() }>
            <div className="columns is-full mx-2">
              <div className="column is-2 is-offset-2 field">
                <label className="label">Nome do Usuário
                  <div className="control">
                  <input className="input" name="name" type="text" defaultValue={ values['name'] } onChange={(e) => handleChangeValues(e.target)} placeholder="Nome do usuário." />
                  <p name="name-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
                </label>
              </div>
              <div className="field column is-2">
                <label className="label">Senha
                  <div className="control">
                  <input className="input" name="password" type="text" onBlur={(e) => handleChangeValues(e.target)} placeholder="Tamanho mínimo 6 caract. (@!#$&)"/>
                  <p name="password-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                </div>
                </label>
              </div>
              <div className="column is-2 field">
                <label className="label">Tipo
                  <div className="control">
                    <div name="role" className="select is-fullwidth">
                      <select className="select" name="role" defaultValue={ values['role'] } onChange={(e) => handleChangeValues(e.target)} >
                        <option value="">Selecione</option>
                        <option value="user">Básico</option>
                        <option value="admin">Administrativo</option>
                      </select>
                      <p name="role-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                    </div>
                  </div>
                </label>
              </div>
              <div className="column is-2 field">
                <label className="label">Ramal do Usuário
                  <div className="control">
                    <div name="endpoint" className="select is-fullwidth">
                      <select className="select" name="endpoint" defaultValue={ values['endpoint'] } onChange={(e) => handleChangeValues(e.target)} >
                        <option value="">  </option>
                        { endpoints.map((endpoint) => <option key={`user-${endpoint}`} value={endpoint}>{ endpoint }</option>) }
                      </select>
                    </div>
                  </div>
                </label>
              </div>
            </div>
            <div className="columns mx-2">
              <div className="column is-offset-4 is-2 field">
                <label className="label">Exibir Ramais
                  <div className="control">
                    <div name="endpointsviewer" className="select is-multiple is-fullwidth">
                      <select multiple name="endpointsviewer" defaultValue={values['endpointsviewer'].includes(',') ? values['endpointsviewer'].split(',').map((option) => option) : [values['endpointsviewer']] } onChange={(e) => handleChangeValues(e.target)} >
                        <option value="all">Todos</option>
                        <option value="none">Nenhum</option>
                        { endpoints.map((endpoint) => <option key={endpoint} value={endpoint}>{ endpoint }</option>) }
                      </select>
                      <p name="endpointsviewer-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                    </div>
                  </div>
                </label>
              </div>
              <div className="column is-2 field">
                <label className="label">Exibir Filas
                  <div className="control">
                    <div name="queuesviewer" className="select is-multiple is-fullwidth">
                      <select multiple name="queuesviewer"  defaultValue={values['queuesviewer'].includes(',') ? values['queuesviewer'].split(',').map((option) => option) : [values['queuesviewer']] } onChange={(e) => handleChangeValues(e.target)} >
                        <option value="all">Todas</option>
                        <option value="none">Nenhuma</option>
                        { queues.map((queue) => <option key={queue} value={queue}>{ queue }</option>) }
                      </select>
                      <p name="queuesviewer-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </form>
          <div id="button-send-form" name="button-send-form" className="columns mt-3">
            <div className="field column mt-3 is-half is-offset-3 has-text-centered">
              <div className="control">
                <button className="button is-info is-fullwidth mt-3" type="submit" onClick={ () => sendDataUsersGenerate() } disabled={ disable }>
                  <span className="icon">
                    <FontAwesomeIcon icon={ faSave } fixedWidth />
                  </span>
                  <span>
                    Alterar Usuário
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default UserById;
